import { Component, effect, inject, OnInit, signal } from '@angular/core';
import {
  IndicatorOverviewTableRow,
  TableServiceService,
} from '../../../services/indicator/table.service.service';
import { TreeTableModule } from 'primeng/treetable';
import { NgForOf, NgIf } from '@angular/common';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import {
  IndicatorValidatorService,
  ValidationResult,
} from '../../../services/indicator/indicator-validator.service';
import { IndicatorValidationListComponent } from '../../molecules/indicator-validation-list/indicator-validation-list.component';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-overview-table-indicator',
  standalone: true,
  imports: [
    TreeTableModule,
    NgForOf,
    NgIf,
    InputTextModule,
    FormsModule,
    ChipModule,
    TagModule,
    ButtonModule,
    SidebarModule,
    IndicatorValidationListComponent,
    HeaderComponent,
    MaskComponent,
  ],
  templateUrl: './overview-table-indicator.component.html',
  styleUrl: './overview-table-indicator.component.scss',
})
export class OverviewTableIndicatorComponent implements OnInit {
  readonly activeUserStore = inject(ActiveUserStore);

  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-screen',
    icon: 'fas fa-clipboard-list',
    headerText: 'Indikatorenbericht',
  };

  validationSidebarVisible = false;
  validationResult: ValidationResult | null = null;

  constructor(
    private sidebarService: SidebarService,
    private indicatorTableService: TableServiceService,
    private validatorService: IndicatorValidatorService
  ) {
    effect(() => {
      if (this.table && this.table.length > 0) return;
      this.initTable();
    });
  }

  table: IndicatorOverviewTableRow[] = [];
  cols: any[] = [];

  ngOnInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }

  initTable() {
    this.cols = this.indicatorTableService.getTableColumns();
    this.table = this.indicatorTableService.indicatorRows();
  }

  validateIndicators() {
    this.validationResult = this.validatorService.validateIndicators();
    this.validationSidebarVisible = true;
  }
}
